/**
 * events - a super-basic Javascript (publish subscribe) pattern
 * Docs: https://gist.github.com/learncodeacademy/777349747d8382bfb722
 */
class Events{

    constructor(){
        this.events = {};
    }

    on(eventName, fn) {
        this.events[eventName] = this.events[eventName] || [];
        this.events[eventName].push(fn);
    }

    off(eventName, fn) {
        if (this.events[eventName]) {
            for (var i = 0; i < this.events[eventName].length; i++) {
                if (this.events[eventName][i] === fn) {
                    this.events[eventName].splice(i, 1);
                    break;
                }
            }
        }
    }

    emit(eventName, data = null) {
        if (this.events[eventName]) {
            this.events[eventName].forEach(function(fn) {
                fn(data);
            });
        }
    }
}

/**
 * Creates a singleton object to be shared in multiple components
 * @type {Events}
 */
export let events = new Events();
